const en = {
  home: {
    biometric_label: "BIOMETRIC IDENTITY VERIFICATION",
    title: "Reverse Search Faces Made Easy",
    description:
      "Upload a high-resolution portrait to cross-reference against global digital archives using advanced neural matching.",
    drag_drop: "Drag and drop your image",
    file_formats: "Supports RAW, JPEG, or PNG (Max 15MB)",
    select_file: "SELECT FILE FROM SYSTEM",
    initiate_scan: "Initiate Forensic Scan",
    upload_hint: "PLEASE UPLOAD AN IMAGE TO CONTINUE",
    uploading: "Uploading",
    searching: "Scanning",
    result_title: "Results",
    drop_here: "Drop the image here...",
    billion_faces: "Compare with over 1 billion faces on the internet",
    login_to_search: "Login to Search",
    login_required: "Login or create an account to use this app",
    not_enough_tokens: "Not enough tokens",
    please_wait: "Please wait a couple of minutes",
    leave_confirmation:
      "There is a process running. Are you sure you want to leave?",
  },
  sources: {
    section_title: "Sources We Search",
    social_media: {
      name: "Social Media",
      description:
        "Cross-references across major social networks and public profiles.",
    },
    web: {
      name: "Web",
      description: "Scans the open web for publicly available face data.",
    },
    scammers: {
      name: "Scammers",
      description:
        "Matches against known scammer identity and fraud databases.",
    },
    sexual_offenders: {
      name: "Sexual Offenders",
      description: "Cross-references public registered offender registries.",
    },
    videos: {
      name: "Videos",
      description: "Extracts and matches faces from public video platforms.",
    },
    police_photos: {
      name: "Police Photos",
      description:
        "Compares against publicly available police record databases.",
    },
    news_and_blogs: {
      name: "News & Blogs",
      description: "Searches news archives, editorial content and blogs.",
    },
  },
  header: {
    scan: "SCAN",
    history: "HISTORY",
    pricing: "PRICING",
    account: "ACCOUNT",
    logout: "LOGOUT",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. All rights reserved. Precision Identity Verification.",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    docs: "Documentation",
    support: "Support",
  },
  common: {
    loading: "Loading...",
    error: "Error",
    cancel: "Cancel",
    back: "Back",
  },
  errors: {
    upload_failed: "Upload failed. Please try again.",
    not_enough_tokens: "You don't have enough tokens to perform this search.",
  },
  login: {
    disclaimer:
      "You need an account to use this app. We don't send spam or share your email. We suggest logging in with Apple to keep it private.",
  },
  results: {
    input_source: "INPUT SOURCE",
    match_thumbnail: "Match thumbnail",
    extraction_id: "EXTRACTION ID",
    scan_analysis: "Scan Analysis",
    scan_description:
      "Bio-metric reverse lookup completed. Found %{count} potential matches across public registries and social indices.",
    col_identity_map: "IDENTITY MAP",
    col_verification_path: "VERIFICATION PATH",
    col_bio_match_score: "BIO-MATCH SCORE",
    col_action: "ACTION",
    export_pdf: "Export PDF",
    exporting: "Generating...",
    verified: "VERIFIED",
    details: "DETAILS",
    details_tooltip: "Run precise face comparison",
    details_loading: "Comparing...",
    copied: "Copied!",
    copy_url: "Copy URL",
    displaying: "Displaying %{count} of %{total} detections",
  },
};

export default en;
